import * as $ from 'jquery';

$(document).on('turbolinks:load', function(){

  $('#upload-modal').on('shown.bs.modal', function () {
    $('.modal').trigger('focus')
  })
});